<template>
    <mobile-menu />
    <mobile-categories-panel />
    <button
        type="button"
        class="mobile-goftino-fab d-md-none"
        aria-label="پشتیبانی آنلاین"
        :aria-busy="supportLoading"
        :disabled="supportLoading"
        @click="openGoftino"
    >
        <span class="icon-Chat"></span>
    </button>
</template>

<script>
export default {
    name: 'MobileShell',
    data: () => ({supportLoading: false}),
    methods: {
        async openGoftino() {
            this.supportLoading = true;
            try {
                await window.openPediniSupport();
            } catch (error) {
                this.errorToast('ارتباط با پشتیبانی برقرار نشد. لطفاً دوباره تلاش کنید.');
            } finally {
                this.supportLoading = false;
            }
        },
    },
};
</script>
